/*-------------------------------------------------------------------------------

  TCCF7 グローバルエラーハンドラー（シングルトン）

--------------------------------------------------------------------------------*/

class TCCF7ErrorHandler {
  static instance = null;

  constructor() {
    if (TCCF7ErrorHandler.instance) {
      return TCCF7ErrorHandler.instance;
    }
    this.errors = [];
    this.debugPanel = null;
    TCCF7ErrorHandler.instance = this;
  }

  /*----------------------------------------
    コンソールにログを出す
  ------------------------------------------*/
  /**
   * @param {string} context - エラー発生場所（クラス名やメソッド名）
   * @param {Error|string} error - エラーオブジェクトまたはメッセージ
   * @param {'error'|'warn'|'info'} severity - 重要度
   */
  log(context, error, severity = 'error') {
    if (typeof tccf7_common === 'undefined' || !tccf7_common.is_debug) return;

    const errorInfo = {
      context,
      message: error.message || error,
      stack: error.stack || null,
      timestamp: new Date().toISOString(),
      severity
    };
    this.errors.push(Object.freeze(errorInfo));

    const logPrefix = `[TCCF7 ${severity.toUpperCase()}] 在: ${context}`;
    if (severity === 'error') {
      console.error(logPrefix, error);
    } else {
      console.warn(logPrefix, error);
    }

    // WP管理者ログイン時のみ詳細パネルを表示
    this.showDebugInfo(errorInfo);
  }

  /*----------------------------------------
    DOMに直接エラーログパネルを生成・表示
  ------------------------------------------*/
  showDebugInfo(errorInfo) {
    if (!this.debugPanel) {
      this.debugPanel = this.createDebugPanel();
    }

    if (!this.debugPanel) return;

    const entry = document.createElement('div');
    entry.style.marginBottom = '8px';
    entry.style.borderBottom = '1px solid #eee';
    entry.style.paddingBottom = '4px';

    const title = document.createElement('strong');
    title.style.color = errorInfo.severity === 'error' ? '#d63638' : '#dba617';
    title.textContent = `[${errorInfo.severity.toUpperCase()}] ${errorInfo.context}`;

    const msg = document.createElement('div');
    msg.style.wordBreak = 'break-all';
    msg.textContent = errorInfo.message;

    entry.appendChild(title);
    entry.appendChild(msg);
    this.debugPanel.appendChild(entry);

    // 最新のエラーが見えるように自動スクロール
    this.debugPanel.scrollTop = this.debugPanel.scrollHeight;
  }

  /*----------------------------------------
    エラーログパネルDOMを生成
  ------------------------------------------*/
  createDebugPanel() {
    const existing = document.getElementById('tccf7-debug-panel');
    if (existing) return existing;

    const panel = document.createElement('div');
    panel.id = 'tccf7-debug-panel';
    panel.setAttribute('role', 'complementary');

    // 閉じるボタン（スタイルはSCSSへ）
    const closeBtn = document.createElement('button');
    closeBtn.className = 'tccf7-debug-close';
    closeBtn.textContent = '× Close Debug';
    closeBtn.onclick = () => panel.remove();

    // 構造の構築
    const title = document.createElement('div');
    title.className = 'tccf7-debug-title';
    title.textContent = 'TCCF7 Debug Mode';

    panel.append(closeBtn, title, document.createElement('hr'));
    document.body?.appendChild(panel);

    return panel;
  }

  /*----------------------------------------
    ユーザー向けエラーメッセージ表示
  ------------------------------------------*/
  /**
   * @param {string} message - ユーザーに提示する翻訳済みメッセージ
   * @param {HTMLElement} targetElement - フォーム等のコンテナ要素
   */
  showUserError(message, targetElement) {
    if (!targetElement) return;
    this.clearUserError(targetElement);
    const errorDiv = document.createElement('div');
    errorDiv.className = 'tccf7-error-message';
    errorDiv.textContent = message;
    errorDiv.setAttribute('role', 'alert');
    targetElement.prepend(errorDiv);
  }

  /**
   * 表示されているユーザー向けエラーメッセージを削除
   */
  clearUserError(targetElement) {
    if (!targetElement) return;
    const existingError = targetElement.querySelector('.tccf7-error-message');
    if (existingError) {
      existingError.remove();
    }
  }

  static getInstance() {
    if (!TCCF7ErrorHandler.instance) {
      TCCF7ErrorHandler.instance = new TCCF7ErrorHandler();
    }
    return TCCF7ErrorHandler.instance;
  }
}

/*-------------------------------------------------------------------------------

  シングルトンインスタンスを作成してエクスポート

--------------------------------------------------------------------------------*/
// インスタンス作成とエクスポート
export const tccf7Logger = TCCF7ErrorHandler.getInstance();